import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthToken } from '../Model/AuthToken.model';

import { HttpClient } from '@angular/common/http';
import { FormControl } from '@angular/forms';


declare var config;
@Injectable()
export class CommonService {
  ipAddress: any;
  ip: string;
  private actionUrl: string;
  private GetIPUrl: string;
  TokenData: AuthToken;

  constructor(private http: Http, private _router: Router,
    private activatedRoute: ActivatedRoute, private httpClient: HttpClient) {

    this.actionUrl = config.APIURL;
    this.GetIPUrl = config.GetIPUrl;

    this.TokenData = JSON.parse(sessionStorage.getItem('Token'));


    this.getIpAddress();
  }

  getIpAddress(){
    this.ipAddress = sessionStorage.getItem('IpAddress');
    if (this.ipAddress === null || this.ipAddress === undefined) {
    this.httpClient.get<{ ip: string }>(this.GetIPUrl).subscribe(response => {
    this.ipAddress = response.ip;
    sessionStorage.setItem('IpAddress', this.ipAddress.toString());
     })
     }
    return this.ipAddress;
     }
  Get(url: string): Promise<any> {


    this.TokenData = JSON.parse(sessionStorage.getItem('Token'));

    if (this.TokenData === undefined || this.TokenData === null) {
      console.log('Tokendata is null or undefined')
      this._router.navigate(['/landing']);
    }
    const headers = new Headers({

      'Content-Type': 'application/json',
      'Authorization': this.TokenData.token_type + ' ' + this.TokenData.access_token,
      'EnterPrisePartnerID': JSON.parse(sessionStorage.getItem('userinfo')).EnterprisePartnerID,
      'CacheManagerID': JSON.parse(sessionStorage.getItem('userinfo')).CacheManagerID,
      'UserID': JSON.parse(sessionStorage.getItem('userinfo')).UserID,
      'SubscriberProductID': config.SubscriberProductID,
      'SubscriberProductCode': config.SubscriberProductCode,
      'SubscriberID': config.SubscriberID,
      'IPAddress': this.ipAddress,
      'TrackingID': sessionStorage.getItem('trackingID'),
    });
    const options = new RequestOptions({ headers: headers });
    return this.http.get(this.actionUrl + url, options)
      .toPromise()
      .then(response => this.extractArray(response))
      .catch(this.handleErrorPromise);
  }


  GetDataWithParameter(strbody: string, url: string): Promise<any> {
    this.TokenData = JSON.parse(sessionStorage.getItem('Token'));

    if (this.TokenData === undefined || this.TokenData === null) {
      console.log('Tokendata is null or undefined')
      this._router.navigate(['/landing']);
    }
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': this.TokenData.token_type + ' ' + this.TokenData.access_token,
      'EnterPrisePartnerID': JSON.parse(sessionStorage.getItem('userinfo')).EnterprisePartnerID,
      'CacheManagerID': JSON.parse(sessionStorage.getItem('userinfo')).CacheManagerID,
      'UserID': JSON.parse(sessionStorage.getItem('userinfo')).UserID,
      'SubscriberProductID': config.SubscriberProductID,
    });
    const options = new RequestOptions({ headers: headers });
    return this.http.get(this.actionUrl + url + '/' + strbody, options)
      .toPromise()
      .then(response => this.extractArray(response))
      .catch(this.handleErrorPromise);
  }

  PostLogin(strbody: any, url: string) {

    const headers = new Headers({
      'Content-Type': 'application/json',
      'SubscriberProductID': config.SubscriberProductID,
      'SubscriberProductCode': config.SubscriberProductCode,
      'SubscriberID': config.SubscriberID,
      'IPAddress': this.ipAddress,
    });
    const options = new RequestOptions({ headers: headers });
    const body = strbody;

    return this.http.post(this.actionUrl + url, body,
      options).toPromise()
      .then(response => this.extractArray(response))
      .catch(this.handleErrorPromise);
  }

  PostTrackIP(strbody: any, url: string) {

    const headers = new Headers({
      'Content-Type': 'application/json',
      'SubscriberProductID': config.SubscriberProductID,
      'EnterPrisePartnerID': JSON.parse(sessionStorage.getItem('userinfo')).EnterprisePartnerID,
    });
    const options = new RequestOptions({ headers: headers });
    const body = strbody;

    return this.http.post(this.actionUrl + url, body,
      options).toPromise()
      .then(response => this.extractArray(response))
      .catch(this.handleErrorPromise);
  }

  PostToken(strbody: any, url: string): Promise<any> {

    const body = 'grant_type=password&Username=' + strbody.Username + '&Password=' + strbody.Password + '';
    const headers = new Headers({
      'Content-Type': 'application/x-www-form-urlencoded',
    });
    const options = new RequestOptions({ headers: headers });
    return this.http.post(this.actionUrl + url, body, options).toPromise()
      .then(response => this.extractArray(response))
      .catch(this.handleErrorPromise);
  }

  Post(strbody: any, url: string) {

    this.TokenData = JSON.parse(sessionStorage.getItem('Token'));

    if (this.TokenData === undefined || this.TokenData === null) {
      console.log('Tokendata is null or undefined')
      this._router.navigate(['/landing']);
    }

    var _searchresult = JSON.parse(sessionStorage.getItem('searchresult'));
    var DeviceInformation = "";
    if (_searchresult !== null && _searchresult !== undefined && _searchresult.length > 0) {
      if (_searchresult[0].StorageCapacity > 0) {
        DeviceInformation = _searchresult[0].DeviceModel + " " + _searchresult[0].StorageCapacity + " " + _searchresult[0].MeasurementUnitType;
      }
      else {
        DeviceInformation = _searchresult[0].DeviceModel;
      }
    }
    var userInfo = JSON.parse(sessionStorage.getItem('userinfo'));
    var IMEI1 = sessionStorage.getItem('_imeiNumber');
    var PassTestId = (sessionStorage.getItem('pricingFilterData'));
    var FailTestId = sessionStorage.getItem('failTestId');
    var SerialNumber = '';
    var isnum = /^\d+$/.test(IMEI1);
    if (!isnum) {
      SerialNumber = IMEI1;
      IMEI1 = '';
    }
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': this.TokenData.token_type + ' ' + this.TokenData.access_token,
      'EnterPrisePartnerID': userInfo != null ? userInfo.EnterprisePartnerID : null,
      'CacheManagerID': userInfo != null ? userInfo.CacheManagerID : null,
      'UserID': userInfo != null ? userInfo.UserID : null,
      'StoreID': userInfo != null ? userInfo.StoreID : null,
      'StoreType': userInfo != null ? userInfo.UserDepartment : null,
      'SubscriberID': config.SubscriberID,
      'SubscriberProductID': config.SubscriberProductID,
      'SubscriberProductCode': config.SubscriberProductCode,
      'IPAddress': this.ipAddress,
      'TrackingID': sessionStorage.getItem('trackingID'),
      'DeviceInformation': DeviceInformation,
      'IMEI1': IMEI1,
      'PassTestId': PassTestId,
      'FailTestId': FailTestId,
      'SerialNumber': SerialNumber,
    });

    const options = new RequestOptions({ headers: headers });
    const body = strbody;
    return this.http.post(this.actionUrl + url, body,
      options).toPromise()
      .then(response => this.extractArray(response))
      .catch(this.handleErrorPromise);
  }
  


  Post1(strbody: any, url: string) {

    const headers = new Headers({
      'Content-Type': 'application/json',
      'SubscriberProductID': config.SubscriberProductID,
      'SubscriberProductCode': config.SubscriberProductCode,
      'SubscriberID': config.SubscriberID,
      'IPAddress': this.ipAddress,
      'TrackingID': sessionStorage.getItem('trackingID'),
    });

    const options = new RequestOptions({ headers: headers });
    const body = strbody;
    return this.http.post(this.actionUrl + url, body,
      options).toPromise()
      .then(response => this.extractArray(response))
      .catch(this.handleErrorPromise);
  }
  PostPartner(strbody: any, url: string) {
    this.TokenData = JSON.parse(sessionStorage.getItem('Token'));
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': this.TokenData.token_type + ' ' + this.TokenData.access_token,
      'EnterPrisePartnerID': strbody.EnterprisePartnerID,
      'CacheManagerID': JSON.parse(sessionStorage.getItem('userinfo')).CacheManagerID,
      'UserID': JSON.parse(sessionStorage.getItem('userinfo')).UserID,
      'SubscriberProductID': config.SubscriberProductID,
      'SubscriberID': config.SubscriberID,
    });

    const options = new RequestOptions({ headers: headers });
    const body = strbody;
    return this.http.post(this.actionUrl + url, body,
      options).toPromise()
      .then(response => this.extractArray(response))
      .catch(this.handleErrorPromise);
  }
  SendEmail(strbody: any, url: string) {

    if (this.TokenData === undefined || this.TokenData === null) {
      console.log('Tokendata is null or undefined')
      this._router.navigate(['/landing']);
    }

    const headers = new Headers({
      'Content-Type': 'application/json',
      'SubscriberProductID': config.SubscriberProductID,
      'SubscriberProductCode': config.SubscriberProductCode,
      'IPAddress': this.ipAddress,
      'TrackingID': sessionStorage.getItem('trackingID'),
    });

    const options = new RequestOptions({ headers: headers });
    const body = strbody;
    return this.http.post(this.actionUrl + url, body,
      options).toPromise()
      .then(response => this.extractArray(response))
      .catch(this.handleErrorPromise);
  }


  protected extractArray(res: Response, showprogress: boolean = true) {
    const data = res.json();
    return data || [];
  }

  private handleErrorPromise(error: Response | any) {

    return Promise.reject(error.message || error);
  }

  public luhncheck(value): boolean {
    // accept only digits, dashes or spaces
    if (/[^0-9-\s]+/.test(value)) return false;

    // The Luhn Algorithm. It's so pretty.
    var nCheck = 0, nDigit = 0, bEven = false;
    value = value.replace(/\D/g, "");

    for (var n = value.length - 1; n >= 0; n--) {
      var cDigit = value.charAt(n),
        nDigit = parseInt(cDigit, 10);

      if (bEven) {
        if ((nDigit *= 2) > 9) nDigit -= 9;
      }

      nCheck += nDigit;
      bEven = !bEven;
    }

    return (nCheck % 10) == 0;
  }


  MCheck(url: string, model: any): Promise<any> {

    const headers = new Headers({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': sessionStorage.getItem('AuthorizationType') + ' ' + sessionStorage.getItem('AuthorizationKey'),
      'EnterPrisePartnerID': JSON.parse(sessionStorage.getItem('userinfo')).EnterprisePartnerID,
      'CacheManagerID': JSON.parse(sessionStorage.getItem('userinfo')).CacheManagerID,
      'SubscriberProductID': config.SubscriberProductID,
      'SubscriberProductCode': config.SubscriberProductCode,
      'IPAddress': this.ipAddress,
      'TrackingID': sessionStorage.getItem('trackingID'),
    });
    const options = new RequestOptions({ headers: headers });
    return this.http.post(this.actionUrl + url, model, options).toPromise()
      .then(response => this.extractArray(response))
      .catch(this.handleErrorPromise);
  }

  gettoken(url: string, model: any): Promise<any> {

    const headers = new Headers({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'EnterPrisePartnerID': JSON.parse(sessionStorage.getItem('userinfo')).EnterprisePartnerID,
      'CacheManagerID': JSON.parse(sessionStorage.getItem('userinfo')).CacheManagerID,

    });
    const options = new RequestOptions({ headers: headers });
    return this.http.post(this.actionUrl + url, model,
      options).toPromise()
      .then(response => this.extractArray(response))
      .catch(this.handleErrorPromise);
  }
  public GetValue(): Promise<any> {
    return this.http.get(`assets/Template/CAUK/OrderSuccessMail.html?v=${new Date().getTime()}`)
      .toPromise()
      .then(response => response.text()
      )
      .catch(this.handleErrorPromise);
  }
  public OrderContractHtml(): Promise<any> {

    return this.http.get(`assets/Template/CAUK/OrderContract.html?v=${new Date().getTime()}`)
      .toPromise()
      .then(response => response.text()
      )
      .catch(this.handleErrorPromise);
  }
  public BoxDetailsHtml(): Promise<any> {

    return this.http.get(`assets/Template/CAUK/BoxDetails.html?v=${new Date().getTime()}`)
      .toPromise()
      .then(response => response.text()
      )
      .catch(this.handleErrorPromise);
  }
  public BagCloseOrders(): Promise<any> {

    return this.http.get(`assets/Template/CAUK/CloseBagOrders.html?v=${new Date().getTime()}`)
      .toPromise()
      .then(response => response.text()
      )
      .catch(this.handleErrorPromise);
  }


  public GetImage(ImageType: string, partnercode: string, DeviceModelID: string): Promise<any> {
    if (ImageType === 'partnerlogo') {
      return this.http.get(`assets/PartnerLogo/CAUK/logo.png?v=${new Date().getTime()}`)
        .toPromise()
        .then(response => response.text()
        )
        .catch(this.handleErrorPromise);
    }
    else if (ImageType === 'celldelogo') {
      return this.http.get(`assets/img/logo.png?v=${new Date().getTime()}`)
        .toPromise()
        .then(response => response.text()
        )
        .catch(this.handleErrorPromise);
    }
    else if (ImageType === 'tradeddeviceimage') {
      return this.http.get(`assets/img/samsung-mobile.jpg?v=${new Date().getTime()}`)
        .toPromise()
        .then(response => response.text()
        )
        .catch(this.handleErrorPromise);
    }


  }

  noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control && control.value && control.value.toString() || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  IsValidEmail(email) {
    if (email.length <= 2) {
      return false;
    }
    if (email.indexOf("@") == -1) {
      return false;
    }

    var parts = email.split("@");
    var prefix = parts[0].length;
    var dot = parts[1].indexOf(".");
    var len = parts[1].length;
    var dotSplits = parts[1].split(".");
    var dotCount = dotSplits.length - 1;

    if (prefix == 0) {
      return false;
    }
    if (dot == -1 || dot < 2 || dotCount > 2) {
      return false;
    }

    for (var i = 0; i < dotSplits.length; i++) {
      if (dotSplits[i].length == 0) {
        return false;
      }
    }
    if (dotSplits[1].length < 2 || dotSplits[1].length > 3) {
      return false;
    }

    return true;
  };

  toHHMMSS(secs) {
    var sec_num = parseInt(secs, 10);
    sec_num = sec_num / 1000;
    var hours = Math.floor(sec_num / 3600)
    var minutes = Math.floor(sec_num / 60) % 60
    var seconds = sec_num % 60

    return [hours, minutes, seconds]
      .map(v => v < 10 ? "0" + v : v)
      .filter((v, i) => v !== "00" || i > 0)
      .join(":");
  }


  PostNewsletterSubscriber(strbody: any, url: string) {

    const headers = new Headers({
      'Content-Type': 'application/json',
    });
    const options = new RequestOptions({ headers: headers });
    const body = strbody;

    return this.http.post(this.actionUrl + url, body,
      options).toPromise()
      .then(response => this.extractArray(response))
      .catch(this.handleErrorPromise);
  }


  RemoveNavbar(){
   var element= document.getElementById("navbar");
   if(element.classList.contains('in'))
   {
   element.classList.remove('in');
   }
  }
  fnLogout() {
    var languageID = sessionStorage.getItem('LanguageID');
    var language = sessionStorage.getItem('language');
    sessionStorage.clear();
    this.clearBrowserBackHistory();
    this._router.navigateByUrl('/');
    sessionStorage.setItem('LanguageID', languageID);
    sessionStorage.setItem('language', language);
  }
  clearBrowserBackHistory(): void {
    history.pushState(null, null, location.href);
    window.onpopstate = function (event) {
      history.go(1);
    };
  }

}
